import React from 'react';
import ChatModal from './components/ChatModal';
import News from './components/News';
import QuickLinks from './components/QuickLinks';
import InterestRates from './components/InterestRates';
import Meetings from './components/Meetings';

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img 
                src="https://doaeweb.icoopsiam.com/static/logo/logo.png?v=1000999" 
                alt="DOAE Logo" 
                className="h-16 w-auto"
              />
              <div className="text-center">
                <h1 className="text-lg font-bold text-gray-800">สหกรณ์ออมทรัพย์กรมส่งเสริมการเกษตร จำกัด</h1>
                {/* <p className="text-sm text-gray-600">DEPARTMENT OF AGRICULTURAL EXTENSION SAVINGS AND CREDIT COOPERATIVES LIMITED.</p> */}
              </div>
            </div>
            <nav className="hidden md:flex space-x-6">
              <a href="#" className="text-gray-600 hover:text-green-800">หน้าหลัก</a>
              <a href="#" className="text-gray-600 hover:text-green-800">เงินฝาก</a>
              <a href="#" className="text-gray-600 hover:text-green-800">เงินกู้</a>
              <a href="#" className="text-gray-600 hover:text-green-800">ดาวน์โหลด</a>
              <a href="#" className="text-gray-600 hover:text-green-800">ผลการดำเนินงาน</a>
              <a href="#" className="text-gray-600 hover:text-green-800">คลังความรู้</a>
              <a href="#" className="text-gray-600 hover:text-green-800">ระเบียบ/ข้อบังคับ</a>
              <a href="#" className="text-gray-600 hover:text-green-800">ติดต่อเรา</a>
            </nav>
          </div>
        </div>
      </header>
      <main className="flex-grow py-8">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="md:col-span-2 space-y-6">
              <News />
              <Meetings />
            </div>
            <div className="space-y-6">
              <QuickLinks />
              <InterestRates />
            </div>
          </div>
        </div>
      </main>
      <footer className="bg-gray-800 text-white py-6">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center">
            <p>© 2024 สหกรณ์ออมทรัพย์กรมส่งเสริมการเกษตร จำกัด. All rights reserved.</p>
          </div>
        </div>
      </footer>
      <ChatModal />
    </div>
  );
}

export default App;
